/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskSessionQuarantinesReleaseSessionQuarantine } from "../funcs/riskSessionQuarantinesReleaseSessionQuarantine.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SessionQuarantine } from "../models/components/sessionquarantine.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ReleaseSessionQuarantineRequest,
  ReleaseSessionQuarantineSecurity,
} from "../models/operations/releasesessionquarantine.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskReleaseSessionQuarantineMutationVariables = {
  request: ReleaseSessionQuarantineRequest;
  security?: ReleaseSessionQuarantineSecurity | undefined;
  options?: RequestOptions;
};

export type RiskReleaseSessionQuarantineMutationData = SessionQuarantine;

export type RiskReleaseSessionQuarantineMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * releaseSessionQuarantine risk
 *
 * @remarks
 * Release an active session quarantine.
 */
export function useRiskReleaseSessionQuarantineMutation(
  options?: MutationHookOptions<
    RiskReleaseSessionQuarantineMutationData,
    RiskReleaseSessionQuarantineMutationError,
    RiskReleaseSessionQuarantineMutationVariables
  >,
): UseMutationResult<
  RiskReleaseSessionQuarantineMutationData,
  RiskReleaseSessionQuarantineMutationError,
  RiskReleaseSessionQuarantineMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskReleaseSessionQuarantineMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskReleaseSessionQuarantine(): MutationKey {
  return ["@gram/client", "sessionQuarantines", "releaseSessionQuarantine"];
}

export function buildRiskReleaseSessionQuarantineMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskReleaseSessionQuarantineMutationVariables,
  ) => Promise<RiskReleaseSessionQuarantineMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskReleaseSessionQuarantine(),
    mutationFn: function riskReleaseSessionQuarantineMutationFn({
      request,
      security,
      options,
    }): Promise<RiskReleaseSessionQuarantineMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskSessionQuarantinesReleaseSessionQuarantine(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
